import { useZoomableCanvas } from "@opstel/EPD/contexts/ZoomableCanvas/useZoomableCanvas";
import { KonvaEventObject } from "konva/lib/Node";
import { useRef, useCallback } from "react";

const REPETITION_INTERVAL = 16;
const ZOOM_STEP = 1.1;

export function useHandleWheelToZoom() {
  const lastCallRef = useRef(0);
  const setPosition = useZoomableCanvas((s) => s.setPosition);
  const handleWheel = useCallback(
    (e: KonvaEventObject<WheelEvent>) => {
      e.evt.preventDefault();
      const now = performance.now();
      if (now - lastCallRef.current < REPETITION_INTERVAL) {
        // ignore events within REPETITION_INTERVAL ms
        return;
      }
      lastCallRef.current = now;

      const stage = e.target.getStage()!;
      const oldScale = stage.scaleX();
      const pointerPointTo = {
        x: stage.getPointerPosition()!.x / oldScale - stage.x() / oldScale,
        y: stage.getPointerPosition()!.y / oldScale - stage.y() / oldScale,
      };

      const newScale = e.evt.deltaY < 0 ? oldScale * ZOOM_STEP : oldScale / ZOOM_STEP;
      const newX = (stage.getPointerPosition()!.x / newScale - pointerPointTo.x) * newScale;
      const newY = (stage.getPointerPosition()!.y / newScale - pointerPointTo.y) * newScale;

      setPosition({ x: newX, y: newY, scale: newScale });
    },
    [setPosition],
  );
  return handleWheel;
}
